import type { ReactNode } from 'react';
import clsx from 'clsx';

interface TableScrollWrapperProps {
  children: ReactNode;
  className?: string;
}

/**
 * Horizontal-scroll layer for wide data tables — used INSIDE the existing
 * `.card` wrappers so narrow viewports swipe sideways instead of overflowing.
 * Pair with a `min-w-[…px]` on the table so columns keep a readable width.
 */
export function TableScrollWrapper({ children, className }: TableScrollWrapperProps): JSX.Element {
  return <div className={clsx('overflow-x-auto', className)}>{children}</div>;
}
